import allKeys from '../allKeys.js';
import identity from '../identity.js';
import isArrayLike from '../isArrayLike.js';

function createForEach(dir) {
    var forEach = function (collection, iteratee) {
        if (iteratee === void 0) { iteratee = identity; }
        var _keys = !isArrayLike(collection) && allKeys(collection);
        var len = (_keys || collection).length;
        var i = dir > 0 ? 0 : len - 1;
        while (i >= 0 && i < len) {
            var currentKey = _keys ? _keys[i] : i;
            if (iteratee(collection[currentKey], currentKey, collection) === false) {
                break;
            }
            i += dir;
        }
        return collection;
    };
    return forEach;
}

export { createForEach as default };
